import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { PAGE_PADDING_Y } from "../../../shared/Page";

const SIDE_BAR_WIDTH = "20rem";

type SettingsPageLayoutProps = {
  sidebarContent: ReactNode;
  mainContent: ReactNode;
};

export const SettingsPageLayout = ({ sidebarContent, mainContent }: SettingsPageLayoutProps) => {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: `${SIDE_BAR_WIDTH} calc(100% - ${SIDE_BAR_WIDTH})` }}>
      <SettingsSidebar>{sidebarContent}</SettingsSidebar>
      {mainContent}
    </Box>
  );
};

const SettingsSidebar = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      sx={{
        borderRight: theme => `1px solid ${theme.palette.grey["300"]}`,
        bgcolor: theme => theme.palette.grey["50"],
        height: "100vh",
        position: "sticky",
        top: 0,
        py: PAGE_PADDING_Y,
        width: SIDE_BAR_WIDTH,
        flexShrink: 0,
        overflowY: "auto",
      }}
    >
      <Stack spacing={4}>{children}</Stack>
    </Stack>
  );
};
